import React, { useState } from 'react';
import styles from '../../styles/AdminStyles/SeatCustomerModal.module.css';

const SeatCustomerModal = ({ isOpen, onClose, onConfirm, mode }) => {
    const [tableNumber, setTableNumber] = useState('');

    if (!isOpen) {
        return null;
    }

    const modalTitle = mode === 'notify' ? 'Notify Customer' : 'Seat Customer';
    const confirmText = mode === 'notify' ? 'Send Notification' : 'Confirm Seat';

    const handleConfirm = () => {
        if (tableNumber.trim()) {
            onConfirm(tableNumber.trim());
            setTableNumber(''); 
        } else {
            alert('Please enter a table number.');
        }
    };

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={e => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>{modalTitle}</h2>
                    <button onClick={onClose} className={styles.closeButton}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                    <label htmlFor="tableNumber" className={styles.label}>Table Number:</label>
                    <input
                        id="tableNumber"
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={tableNumber}
                        onChange={(e) => setTableNumber(e.target.value)}
                        className={styles.input}
                        placeholder="e.g., 14"
                        autoFocus
                    />
                </div>
                <div className={styles.modalFooter}>
                    <button onClick={handleConfirm} className={styles.confirmButton}>
                        {confirmText}
                    </button>
                    <button onClick={onClose} className={styles.cancelButton}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SeatCustomerModal;
